import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Building } from 'src/app/models/building.model';

@Component({
  selector: 'app-form-floor',
  template: `
    <div class="card rounded-5 bg-light">
      <div class="card-header">
        <h2>Agregar piso</h2>
      </div>
      <div class="card-body">
        <form [formGroup]="floorForm" (ngSubmit)="onSubmit(floorForm)">
          <div class="form-group">
            <label for="name">Name</label>
            <input formControlName="name" class="form-control" placeholder="Nombre del piso">
          </div>
          <div class="form-group text-end mt-3">
            <button class="btn btn-link me-2">Cancelar</button>
            <button type="submit" class="btn btn-success">Agregar</button>
          </div>
        </form>
      </div>
    </div>
  `,
  styleUrls: []
})
export class FormFloorComponent implements OnInit {
  @Input() building: any;

  @Output() sendToParent = new EventEmitter<any>();
  
  floorForm: FormGroup = new FormGroup({});

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.floorForm = this.fb.group({
      name: ['', Validators.required],
    });
  }

  onSubmit(form: FormGroup) {
    console.log('form => ', form);
    this.sendToParent.emit(form.value);
  }
}
